import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import * as MenuListUI from 'components/MenuList';
import Box from 'components/Box';
import PopoverCard from 'components/PopoverCard';
import { useComboboxContext } from './Combobox';
import { jsx as _jsx } from "react/jsx-runtime";
function ComboboxMenu(_ref) {
  var children = _ref.children,
    ariaLabel = _ref['aria-label'],
    minWidth = _ref.minWidth;
  var _useComboboxContext = useComboboxContext(),
    popover = _useComboboxContext.popover,
    itemList = _useComboboxContext.itemList,
    statusMessage = _useComboboxContext.statusMessage,
    shouldShowStatusMessage = _useComboboxContext.shouldShowStatusMessage;
  return /*#__PURE__*/_jsx(PopoverCard, _objectSpread(_objectSpread({
    renderInPlace: true,
    renderWhenClosed: true,
    isOpen: popover.isOpen,
    minWidth: minWidth
  }, popover.props), {}, {
    ref: popover.setRef,
    arrow: popover.arrow,
    children: shouldShowStatusMessage ? /*#__PURE__*/_jsx(Box, {
      px: "s",
      py: "xs",
      children: statusMessage
    }) : /*#__PURE__*/_jsx(MenuListUI.Wrapper, {
      role: "listbox",
      "aria-label": ariaLabel,
      id: itemList.listId,
      tabIndex: -1,
      children: children
    })
  }));
}
export default ComboboxMenu;